import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import IAppState from "../../../redux/types/IAppState";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);

export interface IDateDisplayProps {
    value: any;
    customerDatePreference?: string;
    isDateTimeSeperatedBySpaceFromVersionHistory?: boolean;
    showTime?: boolean;
    isUtcTime?: boolean;
    isIncludeSeconds?: boolean;
    customerTimeZone?: string;
    isDateEuropeanFormatFromWorkflows?: boolean;
}

export const YEAR_DAY_MONTH_DATE_FORMAT = "YYYY/DD/MM";
export const DATE_TIME_SEPARATED_BY_SPACE = "DD/MM/YYYY HH:mm:ss";

const DateDisplay: React.FC<IDateDisplayProps> = ({ 
    value, 
    customerDatePreference, 
    isDateEuropeanFormatFromWorkflows, 
    isDateTimeSeperatedBySpaceFromVersionHistory, 
    showTime = false, 
    customerTimeZone, 
    isUtcTime = false, 
    isIncludeSeconds = false 
}) => {
    const [dateToDisplay, setDateToDisplay] = useState('');

    useEffect(() => {
        let newValue = value;
        if (value && value?.value) {
            newValue = value?.value;
        }
        formatDate(newValue)
    }, [value,
    customerTimeZone,
    customerDatePreference,
    showTime,
    isIncludeSeconds,
    isUtcTime,
    isDateTimeSeperatedBySpaceFromVersionHistory,
    isDateEuropeanFormatFromWorkflows
    ]);

    const EUROPEAN_DATE_FORMAT = "DD/MM/YYYY";
    const HOUR_FORMAT = isIncludeSeconds ? "HH:mm:ss" : "HH:mm";
    const TIME = showTime ? ` ${HOUR_FORMAT}` : '';

    let preferenceDateFormat = `${(customerDatePreference ? customerDatePreference : EUROPEAN_DATE_FORMAT)}${TIME}`;
    
    const formatDate = (value) => {
        let dateString = '';

        if (value && value !== '') {
            let date;

            if (isDateTimeSeperatedBySpaceFromVersionHistory) {
                // Parse as UTC with specific format separated by space, then convert to customer's timezone
                date = dayjs.utc(value, DATE_TIME_SEPARATED_BY_SPACE).tz(customerTimeZone);
            } else if (isDateEuropeanFormatFromWorkflows) {
                // Parse as European format, either as UTC or in customer's timezone
                date = isUtcTime
                    ? dayjs.utc(value, EUROPEAN_DATE_FORMAT)
                    : dayjs(value, EUROPEAN_DATE_FORMAT).tz(customerTimeZone);
            } else if (!showTime) {
                // Parse as date only in customer's timezone
                date = dayjs.tz(value, customerTimeZone);
            } else {
                // Default: parse as UTC, then convert to customer's timezone if needed
                date = isUtcTime
                    ? dayjs.utc(value)
                    : dayjs.utc(value).tz(customerTimeZone);
            }

            dateString = date.isValid() ? date.format(preferenceDateFormat) : '';
        }
        setDateToDisplay(dateString)
    }

    return (
        <div className={'flexColumn'} >
            {dateToDisplay}
        </div>
    );
}

export default connect((state: IAppState) => {
    return ({
        customerDatePreference: state.account.customerDate,
        customerTimeZone: state.account.customerTimeZone
    })
})(DateDisplay);